/**
 * Optional "this or that" catalog links: clients cannot select two items that reference each other.
 * Stored as `exclusiveChoiceItemIds: string[]` on each `alaCarteItems` document (peer item ids).
 */

/**
 * @param {unknown} raw
 * @param {string} [selfId] — omit peer equal to own doc id
 * @returns {string[]}
 */
export function normalizeExclusiveChoiceItemIds(raw, selfId) {
  const list = Array.isArray(raw) ? raw : [];
  const out = [];
  const seen = new Set();
  for (const x of list) {
    if (typeof x !== 'string') continue;
    const id = x.trim();
    if (!id || (selfId && id === selfId) || seen.has(id)) continue;
    seen.add(id);
    out.push(id);
    if (out.length >= 40) break;
  }
  return out;
}

/**
 * True if selecting both items should be prevented (symmetric: either doc lists the other).
 * @param {{ id?: string, exclusiveChoiceItemIds?: string[] }|null|undefined} a
 * @param {{ id?: string, exclusiveChoiceItemIds?: string[] }|null|undefined} b
 */
export function areAlaCarteItemsExclusiveChoice(a, b) {
  if (!a || !b || !a.id || !b.id || a.id === b.id) return false;
  const aIds = a.exclusiveChoiceItemIds || [];
  const bIds = b.exclusiveChoiceItemIds || [];
  return aIds.includes(b.id) || bIds.includes(a.id);
}
